module.exports = __webpack_public_path__ + "custom-software.3bU8bhHX.svg";